/** Why a matched deposit waits for a manager (0071). Keep in lockstep with
 *  REASON_* in backend/app/domains/finance/deposit_auto_acceptance.py. */
export const DEPOSIT_REVIEW_REASON_LABEL: Record<string, string> = {
  disabled: 'Auto-acceptance is off',
  wire_not_from_statement: 'Wire captured by hand',
  sender_not_registered: 'Sender account not registered',
  first_deposit: 'First deposit into this product',
  no_limit_for_currency: 'No auto-acceptance limit for this currency',
  above_limit: 'Above the auto-acceptance limit',
  kyc_documents_not_current: 'Documents not current',
  risk_band_high: 'High risk client',
  open_monitoring_alert: 'Open AML monitoring alert',
};

/** The approval checks that can refuse an automatic acceptance (`gate:<code>`),
 *  named after the codes `approve_deposit` raises. */
const GATE_LABEL: Record<string, string> = {
  deposit_currency_mismatch: 'currency does not match the product',
  no_active_contract: 'no active contract',
  wire_not_received: 'wire not received',
  account_frozen: 'account is frozen',
  compliance_review_required: 'compliance review required',
  compliance_review_required_stale: 'compliance review required',
  compliance_review_required_no_identity: 'compliance review required',
  compliance_review_required_screening_unavailable: 'compliance review required',
  system_actor_missing: 'system reviewer unavailable',
};

const GATE_PREFIX = 'gate:';

/** Plain-English label for a review reason. Never shows a raw code. */
export function depositReviewReasonLabel(reason: string): string {
  if (reason.startsWith(GATE_PREFIX)) {
    const gate = GATE_LABEL[reason.slice(GATE_PREFIX.length)];
    return gate ? `Approval check: ${gate}` : 'An approval check did not pass';
  }
  return DEPOSIT_REVIEW_REASON_LABEL[reason] ?? 'Needs manager review';
}
